import React from "react";

const TakeActionCards = ({ item }) => {
  return (
    <div
      key={item?.id}
      className="rounded-2xl p-3 border border-gray-300 dark:border-gray-800 bg-white dark:bg-gray-900/60 hover:bg-gray-50 dark:hover:bg-gray-800/80 flex gap-2.5 items-center w-full cursor-pointer transition-colors"
      onClick={item?.onClick}
    >
      {item?.icon}
      <div className="flex flex-col gap-[-4px]">
        <h6 className="text-[10px] font-semibold text-gray-900 dark:text-gray-200">
          {item?.name}
        </h6>
        <p className="text-[10px] font-normal text-gray-500 dark:text-gray-400">
          {item?.description}
        </p>
      </div>
    </div>
  );
};

export default TakeActionCards;
